module.exports = __webpack_public_path__ + "media/images/emblems/Gemeinde_Buchs-coat_of_arms-c279ff2991430a70f634491bb84994fb.svg";